import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { closeModal } from 'modal/store/actions';
import Title3 from 'base/components/Title3';
import MainTitle from 'base/components/MainTitle';
import FieldWrapper from 'base/components/forms/FieldWrapper';
import Button from 'base/components/Button';
import Row from 'base/components/Row';
import Col from 'base/components/Col';
import { getSelectedDocuments, getSelectedFolders } from '../../store/fileexplorer/selectors';
import { deleteDocument } from '../../store/documents/actions';
import { deleteFolder } from '../../store/folders/actions';


const FileExplorerBulkDelete = ({
  name,
  closeModal,
  deleteFolder,
  deleteDocument,
  documents,
  folders,
}) => {
  const totalFolders = folders.length;
  const totalDocuments = documents.length;
  let description = '';
  if (totalFolders > 0) {
    description += `${totalFolders} ${totalFolders > 1 ? 'folders ' : 'folder '}`;
    if (totalDocuments > 0) {
      description += 'and ';
    }
  }
  if (totalDocuments > 0) {
    description += `${totalDocuments} ${totalDocuments > 1 ? 'documents' : 'document'}`;
  }
  return (
    <>
      <MainTitle withSpaceBelow>Bulk delete</MainTitle>

      <FieldWrapper>
        Do you really want to delete
        <Title3>{description}</Title3>
      </FieldWrapper>

      {totalFolders > 0 && (
      <FieldWrapper>
            This will also delete all child folders and files.
      </FieldWrapper>
      )}

      <Row>
        <Col>
          <Button isFullWidth variant="secondary" onClick={() => closeModal(name)}>No, cancel</Button>
        </Col>
        <Col>
          <Button
            isFullWidth
            variant="primary"
            onClick={() => {
              if (totalFolders > 0) {
                folders.forEach((folder) => deleteFolder(folder));
              }
              if (totalDocuments > 0) {
                documents.forEach((document) => deleteDocument(document));
              }
              closeModal(name);
            }}
          >
            Yes, delete
          </Button>
        </Col>
      </Row>
    </>
  );
};
FileExplorerBulkDelete.propTypes = {
  name: PropTypes.string.isRequired,
  closeModal: PropTypes.func.isRequired,
  deleteFolder: PropTypes.func.isRequired,
  deleteDocument: PropTypes.func.isRequired,
  documents: PropTypes.arrayOf(PropTypes.any).isRequired,
  folders: PropTypes.arrayOf(PropTypes.any).isRequired,
};

const mapStateToProps = (state) => ({
  documents: getSelectedDocuments(state),
  folders: getSelectedFolders(state),
});

const mapDispatchToProps = {
  deleteFolder,
  deleteDocument,
  closeModal,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(FileExplorerBulkDelete);
